<template>
  <div class="BlockChain">
    <common-header></common-header>
    <div class="banner">
      <pub-animate>
        <div class="bannerContent" v-show="showNavPic">
          <div class="left">
            <p
              class="ft36 title"
              :style="
                $route.path.indexOf('en') == 1
                  ? 'width: 656px;margin-bottom: 26px;'
                  : ''
              "
            >
              {{ lanInfo.banner01.title }}
            </p>
            <p
              class="ft18 title marginTop"
              v-html="lanInfo.banner01.content"
            ></p>
          </div>
          <div class="right">
            <div class="right_img">
              <img
                class="enlarge"
                src="./../../assets/images/blockChain/newBanner/legalXchain_img.png"
                alt
                srcset
              />
              <div class="right_img_item">
                <div>
                  <span
                    class="clickDom"
                    style="
                      position: absolute;
                      top: 253px;
                      left: 137px;
                      display: inline-block;
                      width: 60px;
                      height: 60px;
                      z-index: 999;
                      cursor: pointer;
                    "
                  ></span>
                  <img
                    style="position: absolute; top: 203px; left: 146px"
                    src="./../../assets/images/blockChain/newBanner/light_nor_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="none"
                    style="position: absolute; top: 203px; left: 146px"
                    src="./../../assets/images/blockChain/newBanner/light_hpv_pre_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="none"
                    style="position: absolute; top: 291px; left: -118px"
                    src="./../../assets/images/blockChain/newBanner/kljs02_banner_img.png"
                    alt
                    srcset
                  />
                </div>
                <div>
                  <span
                    class="clickDom"
                    style="
                      position: absolute;
                      top: 205px;
                      left: 67px;
                      display: inline-block;
                      width: 60px;
                      height: 60px;
                      z-index: 999;
                      cursor: pointer;
                    "
                  ></span>
                  <img
                    style="position: absolute; top: 163px; left: 79px"
                    src="./../../assets/images/blockChain/newBanner/light_nor_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="none"
                    style="position: absolute; top: 163px; left: 79px"
                    src="./../../assets/images/blockChain/newBanner/light_hpv_pre_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="none"
                    style="position: absolute; top: 217px; left: -164px"
                    src="./../../assets/images/blockChain/newBanner/gjfjg_banner_img.png"
                    alt
                    srcset
                  />
                </div>
                <div>
                  <span
                    class="clickDom"
                    style="
                      position: absolute;
                      top: 153px;
                      left: 0px;
                      display: inline-block;
                      width: 60px;
                      height: 60px;
                      z-index: 999;
                      cursor: pointer;
                    "
                  ></span>
                  <img
                    style="position: absolute; top: 109px; left: 12px"
                    src="./../../assets/images/blockChain/newBanner/light_nor_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="none"
                    style="position: absolute; top: 107px; left: 12px"
                    src="./../../assets/images/blockChain/newBanner/light_hpv_pre_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="none"
                    style="position: absolute; top: 158px; left: -222px"
                    src="./../../assets/images/blockChain/newBanner/njzcw_banner_img.png"
                    alt
                    srcset
                  />
                </div>
                <div>
                  <span
                    class="clickDom"
                    style="
                      position: absolute;
                      top: 116px;
                      left: 64px;
                      display: inline-block;
                      width: 60px;
                      height: 60px;
                      z-index: 999;
                      cursor: pointer;
                    "
                  ></span>
                  <img
                    style="position: absolute; top: 77px; left: 70px"
                    src="./../../assets/images/blockChain/newBanner/light_nor_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="none"
                    style="position: absolute; top: 77px; left: 70px"
                    src="./../../assets/images/blockChain/newBanner/light_hpv_pre_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="none"
                    style="position: absolute; top: 144px; left: -165px"
                    src="./../../assets/images/blockChain/newBanner/sfjdzx_img.png"
                    alt
                    srcset
                  />
                </div>
                <div>
                  <span
                    class="clickDom"
                    style="
                      position: absolute;
                      top: 98px;
                      left: 398px;
                      display: inline-block;
                      width: 60px;
                      height: 60px;
                      z-index: 999;
                      cursor: pointer;
                    "
                  ></span>
                  <img
                    style="position: absolute; top: 68px; left: 409px"
                    src="./../../assets/images/blockChain/newBanner/light_nor_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="none"
                    style="position: absolute; top: 68px; left: 409px"
                    src="./../../assets/images/blockChain/newBanner/light_hpv_pre_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="none"
                    style="position: absolute; top: 54px; left: 431px"
                    src="./../../assets/images/blockChain/newBanner/flkjyy_banner_img.png"
                    alt
                    srcset
                  />
                </div>
                <div>
                  <span
                    class="clickDom"
                    style="
                      position: absolute;
                      top: 146px;
                      left: 462px;
                      display: inline-block;
                      width: 60px;
                      height: 60px;
                      z-index: 999;
                      cursor: pointer;
                    "
                  ></span>
                  <img
                    style="position: absolute; top: 98px; left: 468px"
                    src="./../../assets/images/blockChain/newBanner/light_nor_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="none"
                    style="position: absolute; top: 98px; left: 468px"
                    src="./../../assets/images/blockChain/newBanner/light_hpv_pre_img.png"
                    alt
                    srcset
                  />
                  <div class="none content_box">浙江亦笔金法科技有限公司</div>
                </div>
                <div>
                  <span
                    class="clickDom"
                    style="
                      position: absolute;
                      top: 213px;
                      left: 398px;
                      display: inline-block;
                      width: 60px;
                      height: 60px;
                      z-index: 999;
                      cursor: pointer;
                    "
                  ></span>
                  <img
                    style="position: absolute; top: 165px; left: 406px"
                    src="./../../assets/images/blockChain/newBanner/light_nor_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="block"
                    style="position: absolute; top: 165px; left: 406px"
                    src="./../../assets/images/blockChain/newBanner/light_hpv_pre_img.png"
                    alt
                    srcset
                  />
                  <div class="block swiper-con">
                    <swiper
                      v-if="swipershow"
                      class="swiper"
                      :options="swiperOptions"
                    >
                      <swiper-slide
                        v-for="item in swiperList"
                        :key="item.name"
                        >{{ item.name }}</swiper-slide
                      >
                    </swiper>
                  </div>
                </div>
                <div>
                  <span
                    class="clickDom"
                    style="
                      position: absolute;
                      top: 294px;
                      left: 341px;
                      display: inline-block;
                      width: 60px;
                      height: 60px;
                      z-index: 999;
                      cursor: pointer;
                    "
                  ></span>
                  <img
                    style="position: absolute; top: 240px; left: 350px"
                    src="./../../assets/images/blockChain/newBanner/light_nor_img.png"
                    alt
                    srcset
                  />
                  <img
                    class="none"
                    style="position: absolute; top: 240px; left: 350px"
                    src="./../../assets/images/blockChain/newBanner/light_hpv_pre_img.png"
                    alt
                    srcset
                  />
                  <div class="none swiper-con content_bank">
                    <swiper
                      v-if="swipershow"
                      class="swiper"
                      :options="swiperOptionBank"
                    >
                      <swiper-slide
                        v-for="item in swiperBankList"
                        :key="item.name"
                        >{{ item.name }}</swiper-slide
                      >
                    </swiper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </pub-animate>
    </div>
    <!-- 当前区块总览 -->
    <div class="currentBlocks">
      <div class="content">
        <div class="currentBlocks_title">
          <img src="./../../assets/images/blockChain/Overview_icon.png" />
          <span>{{ lanInfo.blockOverview }}</span>
        </div>
        <!-- 总和数据 -->
        <div class="blockOverview">
          <div class="blockOverview_item">
            <p>{{ lanInfo.blockHeightOverview }}</p>
            <p>{{ blockInfo ? blockInfo.blockNum : "" }}</p>
          </div>
          <div class="blockOverview_item">
            <p>{{ lanInfo.nodeNumberOverview }}</p>
            <p>{{ blockInfo ? blockInfo.nodeCount : "" }}</p>
          </div>
          <div class="blockOverview_item">
            <p>{{ lanInfo.tradingCapacityOverview }}</p>
            <p>{{ blockInfo ? blockInfo.txCount : "" }}</p>
          </div>
        </div>
        <div class="currentBlockDatas">
          <!-- 总览菜单 -->
          <div class="BlockDatas_nav">
            <p
              v-for="(item, ind) in newBlockInfoList"
              :key="ind"
              @mouseover="changeBankNav(item, ind)"
              @mouseleave="changeBankNav(item, ind)"
              :class="{ blankActive: item.active }"
            >
              {{ item.title }}
            </p>
          </div>
          <div
            class="BlockDatas_info"
            v-for="(item, inds) in newBlockInfoList"
            :key="inds"
            v-if="curBankNavInd == inds"
          >
            <div class="lefts">
              <img
                src="./../../assets/images/blockChain/block_icon.png"
                alt
                srcset
              />
              <span class="nums">
                <p class="ft16 color" style="font-size: 16px">
                  {{ lanInfo.blockHeight }}
                </p>
                <p>{{ item.blockNum }}</p>
              </span>
            </div>
            <div class="vertical_line"></div>
            <div class="lefts">
              <img
                src="./../../assets/images/blockChain/node_icon.png"
                alt
                srcset
              />
              <span class="nums">
                <p class="ft16 color" style="font-size: 16px">
                  {{ lanInfo.nodeNumber }}
                </p>
                <p>{{ item.nodeCount }}</p>
              </span>
            </div>
            <div class="vertical_line"></div>
            <div class="lefts">
              <img
                src="./../../assets/images/blockChain/transactions_icon.png"
                alt
                srcset
              />
              <span class="nums">
                <p class="ft16 color" style="font-size: 16px">
                  {{ lanInfo.tradingCapacity }}
                </p>
                <p>{{ item.txCount }}</p>
              </span>
            </div>
            <div class="vertical_line"></div>
            <div class="lefts">
              <img
                v-show="item.status == 1"
                src="./../../assets/images/blockChain/status_yxz_icon.png"
                alt
                srcset
              />
              <img
                v-show="item.status != 1"
                src="./../../assets/images/blockChain/status_gj_icon.png"
                alt
                srcset
              />
              <span class="nums">
                <p class="ft16 color" style="font-size: 16px">
                  {{ lanInfo.netState }}
                </p>
                <p class="ft26">
                  {{
                    item.status == 1
                      ? lanInfo.networkState.status1
                      : lanInfo.networkState.status3
                  }}
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索 -->
    <div class="searchBlock">
      <vue-particles
        color="#7b7d7d"
        :particleOpacity="0.7"
        :particlesNumber="60"
        shapeType="circle"
        :particleSize="4"
        linesColor="#203c77"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="100"
        :moveSpeed="2"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
        class="lizi"
      ></vue-particles>
      <div class="input">
        <el-input
          :placeholder="lanInfo.queryId"
          v-model="value"
          class="input-with-select"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            v-on:click="handelSearch()"
          ></el-button>
        </el-input>
      </div>
      <div class="table">
        <table
          class="table"
          style="
            white-space: normal;
            word-break: break-all;
            margin-top: 0px;
            height: 60px;
            width: 100%;
            top: 0px;
          "
        >
          <thead
            style="position: absolute; left: 0; top: 0; width: 100%; z-index: 3"
          >
            <tr
              style="
                background-color: #e4e4e4 !important;
                width: 100%;
                float: left;
                border-right: 1px solid #d2d2d2;
              "
            >
              <td style="width: 170px; text-align: center">
                {{ lanInfo.transactionTime }}
              </td>
              <td style="width: 345px; text-align: center">
                {{ lanInfo.transactionId }}
              </td>
              <td style="width: 170px; text-align: center">
                {{ lanInfo.node }}
              </td>
              <td style="width: 170px; text-align: center">
                {{ lanInfo.subject }}
              </td>
              <td style="width: 345px; text-align: center">
                {{ lanInfo.hash }}
              </td>
            </tr>
          </thead>
          <tbody class="table-lists">
            <tr
              v-if="!isBlock"
              style="
                border-bottom: 1px solid #d2d2d2;
                border-right: 1px solid #d2d2d2;
              "
            >
              <td style="width: 170px; text-align: center">
                {{ searchData.createTime }}
              </td>
              <td style="width: 345px; text-align: center">
                {{ searchData.txId }}
              </td>
              <td style="width: 170px; text-align: center">
                {{ searchData.nodeName }}
              </td>
              <td style="width: 170px; text-align: center">
                {{ searchData.owner ? searchData.owner : "***" }}
              </td>
              <td style="width: 345px; text-align: center">
                {{ searchData.blockHash }}
              </td>
            </tr>
            <p class="ft16 err" v-show="isBlock">{{ lanInfo.enterQueryId }}</p>
          </tbody>
        </table>
      </div>
    </div>
    <!-- 区块链记录 start-->
    <img
      class="chainRecord"
      src="./../../assets/images/qukuailogo.png"
      alt
      srcset
    />
    <p class="ft28" style="margin-bottom: 29px">
      {{ lanInfo.BlockchainRecord }}
    </p>
    <div class="chainRecord_table_nav">
      <div class="content">
        <div class="chainRecord_table_nav_con">
          <div
            class="chainRecord_table_nav_item"
            v-for="(item, ind) in tableNavList"
            v-if="item.isShow"
            :key="ind"
            @click="changeChainRecord(item, ind)"
          >
            <p :class="{ table_nav_active: item.active }">{{ item.title }}</p>
            <div :class="{ table_nav_line: item.active }"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- M链 -->
    <div class="tab" v-if="curChainRecord == 0">
      <div class="latestCertificate">
        <table
          class="table"
          style="
            white-space: normal;
            word-break: break-all;
            margin-top: 0;
            width: 100%;
          "
        >
          <thead style="z-index: 3; border-right: 1px solid #d2d2d2">
            <tr style="background-color: #e4e4e4 !important; width: 100%">
              <td style="width: 170px; text-align: center">
                {{ lanInfo.transactionTime }}
              </td>
              <td style="width: 345px; text-align: center">
                {{ lanInfo.transactionId }}
              </td>
              <td style="width: 170px; text-align: center">
                {{ lanInfo.node }}
              </td>
              <td style="width: 170px; text-align: center">
                {{ lanInfo.subject }}
              </td>
              <td style="width: 345px; text-align: center">
                {{ lanInfo.hash }}
              </td>
            </tr>
          </thead>
          <tbody class="table-list" style="border-right: 1px solid #d2d2d2">
            <tr v-for="(item, index) in txList" :key="index">
              <td style="width: 170px; text-align: center">
                {{ item.createTime }}
              </td>
              <td style="width: 345px; text-align: center">{{ item.txId }}</td>
              <td style="width: 170px; text-align: center">
                {{ item.nodeName }}
              </td>
              <td style="width: 170px; text-align: center">{{ item.owner }}</td>
              <td style="width: 345px; text-align: center">
                {{ item.blockHash }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- F链 -->
    <div class="tab" v-if="curChainRecord == 1">
      <div class="latestCertificate">
        <table
          class="table"
          style="
            white-space: normal;
            word-break: break-all;
            margin-top: 0;
            width: 100%;
          "
        >
          <thead style="z-index: 3; border-right: 1px solid #d2d2d2">
            <tr style="background-color: #e4e4e4 !important; width: 100%">
              <td style="width: 170px; text-align: center">
                {{ lanInfo.transactionTime }}
              </td>
              <td style="width: 345px; text-align: center">
                {{ lanInfo.transactionId }}
              </td>
              <td style="width: 260px; text-align: center">
                {{ lanInfo.node }}
              </td>
              <td style="width: 345px; text-align: center">
                {{ lanInfo.hash }}
              </td>
            </tr>
          </thead>
          <tbody class="table-list" style="border-right: 1px solid #d2d2d2">
            <tr v-for="(item, index) in txListF" :key="index">
              <td style="width: 170px; text-align: center">
                {{ item.createTime }}
              </td>
              <td style="width: 345px; text-align: center">{{ item.txId }}</td>
              <td style="width: 260px; text-align: center">
                {{ item.nodeName }}
              </td>
              <td style="width: 345px; text-align: center">
                {{ item.blockHash }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- G链 -->
    <div class="tab" v-if="curChainRecord == 2">
      <div class="latestCertificate">
        <table
          class="table"
          style="
            white-space: normal;
            word-break: break-all;
            margin-top: 0;
            width: 100%;
          "
        >
          <thead style="z-index: 3; border-right: 1px solid #d2d2d2">
            <tr style="background-color: #e4e4e4 !important; width: 100%">
              <td style="width: 170px; text-align: center">
                {{ lanInfo.transactionTime }}
              </td>
              <td style="width: 345px; text-align: center">
                {{ lanInfo.transactionId }}
              </td>
              <td style="width: 170px; text-align: center">
                {{ lanInfo.node }}
              </td>
              <td style="width: 170px; text-align: center">
                {{ lanInfo.subject }}
              </td>
              <td style="width: 345px; text-align: center">
                {{ lanInfo.hash }}
              </td>
            </tr>
          </thead>
          <tbody class="table-list" style="border-right: 1px solid #d2d2d2">
            <tr v-for="(item, index) in txListG" :key="index">
              <td style="width: 170px; text-align: center">
                {{ item.createTime }}
              </td>
              <td style="width: 345px; text-align: center">{{ item.txId }}</td>
              <td style="width: 170px; text-align: center">
                {{ item.nodeName }}
              </td>
              <td style="width: 170px; text-align: center">{{ item.owner }}</td>
              <td style="width: 345px; text-align: center">
                {{ item.blockHash }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- 区块链记录 end-->
    <!-- 区块链网络状态 -->
    <network-state
      v-on:getStatus="getstatusFn"
      v-on:getnodeList="nodeListFn"
      v-on:getBlockInfo="blockInfoFn"
      v-on:gettxListF="txListFnF"
      v-on:gettxListG="txListFnG"
      v-on:getBlockInfoList="getBlockInfoList"
      v-on:gettxList="txListFn"
    ></network-state>
    <!-- 区块链介绍 -->
    <p class="ft26 jieshao">{{ lanInfo.legalXchainDscp }}</p>
    <div class="allianceChain" :class="{ enAllianceChain: lanType == 'en' }">
      <div class="allianceChainNew">
        <div class="allianceChainCon">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide>
              <div class="item item_01">
                <img
                  class="bg"
                  src="./../../assets/images/list1.png"
                  alt
                  srcset
                />
                <img
                  class="img_01"
                  src="./../../assets/images/jjfa_jdsfcb.png"
                  alt
                  srcset
                />
                <p class="ft20 p_01">
                  {{ lanInfo.legalXchainDscpBlock1.title }}
                </p>
                <div class="item_001 item_0001">
                  <img src="./../../assets/images/jjfa_jdsfcb.png" alt srcset />
                  <p class="ft20">{{ lanInfo.legalXchainDscpBlock1.title }}</p>
                  <p class="con TextIndent textAlignJus">
                    {{ lanInfo.legalXchainDscpBlock1.content }}
                  </p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="item item_02 swiper-slide">
                <img
                  class="bg"
                  src="./../../assets/images/list2.png"
                  alt
                  srcset
                />
                <img
                  class="img_02"
                  src="./../../assets/images/jieshao_sjgd.png"
                  alt
                  srcset
                />
                <p class="ft20 p_02">
                  {{ lanInfo.legalXchainDscpBlock2.title }}
                </p>
                <div class="item_001 item_0002">
                  <img
                    src="./../../assets/images/jieshao_sjgd.png"
                    alt
                    srcset
                  />
                  <p class="ft20">{{ lanInfo.legalXchainDscpBlock2.title }}</p>
                  <p class="con TextIndent textAlignJus">
                    {{ lanInfo.legalXchainDscpBlock2.content }}
                  </p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="item item_03 swiper-slide">
                <img
                  class="bg"
                  src="./../../assets/images/list3.png"
                  alt
                  srcset
                />
                <img
                  class="img_03"
                  src="./../../assets/images/jieshao_tsxl.png"
                  alt
                  srcset
                />
                <p class="ft20 p_03">
                  {{ lanInfo.legalXchainDscpBlock3.title }}
                </p>
                <div class="item_001 item_0003">
                  <img
                    src="./../../assets/images/jieshao_tsxl.png"
                    alt
                    srcset
                  />
                  <p class="ft20">{{ lanInfo.legalXchainDscpBlock3.title }}</p>
                  <p class="con TextIndent textAlignJus">
                    {{ lanInfo.legalXchainDscpBlock3.content }}
                  </p>
                </div>
              </div>
            </swiper-slide>

            <swiper-slide>
              <div class="item item_04 swiper-slide">
                <img
                  class="bg"
                  src="./../../assets/images/list4.png"
                  alt
                  srcset
                />
                <img
                  class="img_04"
                  src="./../../assets/images/jjfa_zxsj.png"
                  alt
                  srcset
                />
                <p class="ft20 p_04">
                  {{ lanInfo.legalXchainDscpBlock4.title }}
                </p>
                <div class="item_001 item_0004">
                  <img src="./../../assets/images/jjfa_zxsj.png" alt srcset />
                  <p class="ft20">{{ lanInfo.legalXchainDscpBlock4.title }}</p>
                  <p class="con TextIndent textAlignJus">
                    {{ lanInfo.legalXchainDscpBlock4.content }}
                  </p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="item item_05 swiper-slide">
                <img
                  class="bg"
                  src="./../../assets/images/list5.png"
                  alt
                  srcset
                />
                <img
                  class="img_05"
                  src="./../../assets/images/jjfa_axxl.png"
                  alt
                  srcset
                />
                <p class="ft20 p_05">
                  {{ lanInfo.legalXchainDscpBlock5.title }}
                </p>
                <div class="item_001 item_0005">
                  <img src="./../../assets/images/jjfa_axxl.png" alt srcset />
                  <p class="ft20">{{ lanInfo.legalXchainDscpBlock5.title }}</p>
                  <p class="con TextIndent textAlignJus">
                    {{ lanInfo.legalXchainDscpBlock5.content }}
                  </p>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
          </swiper>
          <div
            class="swiper-button-prev"
            slot="button-prev"
            style="left: -44px"
          ></div>
          <div
            class="swiper-button-next"
            slot="button-next"
            style="right: -44px"
          ></div>
        </div>
      </div>
    </div>
    <p class="ft26 advantage">{{ lanInfo.goodnessBlock }}</p>
    <div class="advantageCon">
      <span class="item">
        <img src="./../../assets/images/qukuailian_list1.png" alt srcset />
        <p class="ft16 info">{{ lanInfo.goodnessBlockItem1 }}</p>
      </span>
      <span class="item marginLeft150">
        <img src="./../../assets/images/qukuailian_list2.png" alt srcset />
        <p class="ft16 info">{{ lanInfo.goodnessBlockItem2 }}</p>
      </span>
      <span class="item marginLeft150">
        <img src="./../../assets/images/qukuailian_list3.png" alt srcset />
        <p class="ft16 info">{{ lanInfo.goodnessBlockItem3 }}</p>
      </span>
      <span class="item marginLeft150">
        <img src="./../../assets/images/qukuailian_list4.png" alt srcset />
        <p class="ft16 info">{{ lanInfo.goodnessBlockItem4 }}</p>
      </span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { getTime } from "@/utils/validate.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import networkState from "./networkState.vue";
export default {
  data() {
    return {
      value: "",
      activeName: "first",
      swipershow: false,
      statusPeer: true,
      nodeList: [],
      txList: [],
      txListF: [],
      txListG: [],
      blockInfo: { blockNum: 0, txCount: 0, nodeCount: 0 },
      blockInfoList: [],
      newBlockInfoList: [
        {
          title: "legalXchain M",
          active: true,
          blockName: "M",
          isShow: true,
          blockNum: 0,
          txCount: 0,
          nodeCount: 0,
        },
        {
          title: "legalXchain F",
          active: false,
          blockName: "F",
          isShow: true,
          blockNum: 0,
          txCount: 0,
          nodeCount: 0,
        },
        {
          title: "legalXchain G",
          active: false,
          blockName: "G",
          isShow: true,
          blockNum: 0,
          txCount: 0,
          nodeCount: 0,
        },
      ],
      swiperBankList: [
        {
          name: "昆山****银行",
        },
        {
          name: "江苏****银行",
        },
        {
          name: "广东****银行",
        },
        {
          name: "东莞****银行",
        },
      ],
      swiperList: [
        {
          name: "北京市东方公证处",
        },
        {
          name: "北京市方正公证处",
        },
        {
          name: "北京市长安公证处",
        },
        {
          name: "北京市国信公证处",
        },
        {
          name: "北京市精诚公证处",
        },
        {
          name: "北京市信德公证处",
        },
        {
          name: "杭州互联网公证处",
        },
        {
          name: "河北省香河公证处",
        },
        {
          name: "河北省沧州市渤海公证处",
        },
        {
          name: "广州市海珠公证处",
        },
        {
          name: "广东省广州市广州公证处",
        },
        {
          name: "浙江省温州市华东公证处",
        },
        {
          name: "江苏省南京市石城公证处",
        },
        {
          name: "厦门开元公证处",
        },
        {
          name: "福建省福州市闽江公证处",
        },
        {
          name: "佛山市电子证据固化平台",
        },
        {
          name: "EC源数字备案平台",
        },
        {
          name: "蓝信电子签约平台",
        },
        {
          name: "北京市方圆公证处",
        },
        {
          name: "四川省成都市国力公证处",
        },
        {
          name: "江西省南昌市大成公证处",
        },
        {
          name: "天津市辰信公证处",
        },
        {
          name: "天津市滨海公证处",
        },
        {
          name: "江西省南昌市豫章公证处",
        },
        {
          name: "上海市东方公证处",
        },
        {
          name: "浙江省杭州市之江公证处",
        },
        {
          name: "辽宁省鞍山市立山公证处",
        },
        {
          name: "辽宁省大连市大连公证处",
        },
      ],
      //交易记录菜单
      tableNavList: [
        {
          title: "legalXchain M",
          active: true,
          isShow: false,
        },
        {
          title: "legalXchain F",
          active: false,
          isShow: false,
        },
        {
          title: "legalXchain G",
          active: false,
          isShow: false,
        },
      ],
      curBankNavInd: 0,
      swiperOptions: {
        direction: "vertical",
        slidesPerView: 3,
        mousewheel: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 1000,
        },
        loop: true,
      },
      swiperOption: {
        slidesPerView: 4,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionBank: {
        slidesPerView: 3,
        direction: "vertical",
        mousewheel: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 1000,
        },
        loop: true,
      },
      showNavPic: false,
      isBlock: true,
      searchData: [],
      curChainRecord: 0, //当前区块链记录菜单
    };
  },
  components: {
    networkState,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    lanInfo() {
      return this.$store.getters.getLanInfo.blockChain;
    },
    lanType() {
      return this.$store.getters.getLanType;
    },
  },

  mounted() {
    var self = this;
    this.swipershow = true;
    // this.swiper.slideTo(3, 1000, false);
    setTimeout(() => {
      this.showNavPic = true;
    }, 100);

    this.changebanner();
    //首次进入开关
    sessionStorage.removeItem("flag");
    //菜单选中样式
    sessionStorage.setItem("curBankInd", 0);
  },
  methods: {
    //运行状态
    getstatusFn(status) {
      this.statusPeer = status;
    },
    nodeListFn(nodeList) {
      this.nodeList = nodeList;
    },
    blockInfoFn(blockInfo) {
      if (blockInfo.blockNum && blockInfo.blockNum != "0") {
        this.blockInfo.blockNum = blockInfo.blockNum;
      }
      if (blockInfo.txCount && blockInfo.txCount != "0") {
        this.blockInfo.txCount = blockInfo.txCount;
      }
      if (blockInfo.nodeCount && blockInfo.nodeCount != "0") {
        this.blockInfo.nodeCount = blockInfo.nodeCount;
      }
    },
    txListFn(txList) {
      if (txList.length) {
        this.txList = this.getNewTxList(txList, this.txList);
        this.tableNavList[0].isShow = true;
      }
    },
    txListFnF(txListF) {
      if (txListF.length) {
        this.txListF = this.getNewTxList(txListF, this.txListF);
        this.tableNavList[1].isShow = true;
      }
    },
    txListFnG(txListG) {
      if (txListG.length) {
        this.txListG = this.getNewTxList(txListG, this.txListG);
        this.tableNavList[2].isShow = true;
      }
    },
    /***
     * 获取最新前10条数据
     * newList：最新数据
     * oldList：已有数据
     */
    getNewTxList(newList, oldList) {
      let newArr = oldList,
        resultList = [];
      if (newList.length == 10) {
        resultList = newList;
      } else {
        if (newArr.length && newArr.length < 10) {
          newArr.unshift(...newList);
        } else {
          if (!newArr.length) {
            newArr.push(...newList);
          } else {
            newArr.unshift(...newList);
            newArr = newArr.slice(0, 10);
          }
        }
        resultList = newArr;
      }
      return resultList;
    },
    //区块高度数据详情
    getBlockInfoList(blockInfoList) {
      let newData = blockInfoList;
      if (newData.length) {
        if (sessionStorage.getItem("flag")) {
          //不是第一次进入，只更新有变化的数据
          this.newBlockInfoList.forEach((item, ind) => {
            newData.forEach((ele, val) => {
              if (item.blockName == ele.blockName) {
                for (let i in ele) {
                  if (i == "blockNum" || i == "txCount" || i == "nodeCount") {
                    if (ele[i] != "" && ele[i] != undefined && ele[i] != 0) {
                      item[i] = ele[i];
                    }
                  }
                  if (i == "status" && (ele[i] == 1 || ele[i] == 0)) {
                    item[i] = ele[i];
                  }
                }
              }
            });
          });
        } else {
          //第一次进入
          sessionStorage.setItem("flag", 1);
          blockInfoList.forEach((item, index) => {
            item.title = "legalXchain " + item.blockName;
            if (
              sessionStorage.getItem("curBankInd") &&
              sessionStorage.getItem("curBankInd") == index
            ) {
              item.active = true;
            } else {
              item.active = false;
            }
          });
          this.newBlockInfoList = blockInfoList;
        }
        this.$forceUpdate();
      }
    },
    //点击切换总览菜单
    changeBankNav(item, ind) {
      this.newBlockInfoList.forEach((element) => {
        element.active = false;
      });
      sessionStorage.setItem("curBankInd", ind);
      this.curBankNavInd = ind;
      this.newBlockInfoList[ind].active = true;
      this.$forceUpdate();
    },
    //鼠标经过切换菜单
    mouseBankNav(ind, flag) {
      if (flag) {
        this.curBankNavInd = ind;
      } else {
        this.curBankNavInd = JSON.parse(sessionStorage.getItem("curBankInd"));
      }
    },
    //区块链交易记录点击切换菜单
    changeChainRecord(item, ind) {
      this.tableNavList.forEach((item) => {
        item.active = false;
      });
      this.tableNavList[ind].active = true;
      this.curChainRecord = ind;
    },
    //改变banner
    changebanner() {
      let _this = this;
      $(".clickDom").hover(function () {
        $(".clickDom").next().next().next().addClass("none");
        $(".clickDom").next().next().next().removeClass("block");
        $(".clickDom").next().next().addClass("none");
        $(".clickDom").next().next().removeClass("block");
        $(this).next().next().next().addClass("block");
        $(this).next().next().addClass("block");
      });
    },
    handelSearch() {
      let txId = this.value.trim();
      this.$ajax
        .get("/webapi/tx/queryByTxId", { params: { txId: txId } })
        .then((res) => {
          if (res.data.code == 200) {
            // console.log(res,'查询id结果')
            this.searchData = res.data.extraData.data;
            this.isBlock = false;
            this.value = "";
          } else {
            this.isBlock = true;
          }
        });
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "";
      }
      return "warning-row";
    },
  },
};
</script>

<style scoped lang="scss">
table.table tr td {
  border-top: 1px solid #d2d2d2;
  border-left: 1px solid #d2d2d2;
}
.table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  /*margin-top: 20px;*/
  position: relative;
}

.table tr td {
  /*border: solid 1px #d2d2d2;*/
  color: #888888;
  font-size: 14px;
  /*line-height: 30px;*/
  padding: 10px;
  line-height: 18px;
  vertical-align: middle;
}
.table > tr:nth-child(odd),
.table thead > tr:nth-child(odd),
.table tbody > tr:nth-child(odd) {
  background-color: #fff !important;
}

.table > tr:hover,
.table thead > tr:hover,
.table tbody > tr:hover {
  background-color: #f1f1f1 !important;
}

.table > thead {
  background-color: rgb(210, 210, 210);
}
.table > thead td {
  color: #595959;
}
.table tr {
  height: 42px;
  line-height: 42px;
}

.record-content {
  width: 1200px;
  /*height: 665px;*/
  overflow: hidden;
  background-color: #f9f9f9;
  /*padding: 30px;*/
  margin: 0 auto;
}
.table-lists {
  position: absolute;
  left: 0;
  top: 42px;
  z-index: 2;
  // border-bottom: 1px solid #d2d2d2;
}
.table-list {
  // position: absolute;
  left: 0;
  top: 42px;
  z-index: 2;
  border-bottom: 1px solid #d2d2d2;
}
.table > .table-list > tr {
  background-color: #fff !important;
}
.enlarge {
  cursor: pointer;
  transition: all 0.7s ease-in-out 0s;
}
.content {
  width: 1200px;
  margin: 0 auto;
}
.BlockChain {
  width: 100%;
  .banner {
    width: 100%;
    height: 418px;
    background-image: url("./../../assets/images/blockChain/qklllq_banner_bg.png");
    background-size: 100% 100%;
    overflow: hidden;
    position: relative;
    z-index: 0;
    .bannerContent {
      position: relative;
      width: 1200px;
      margin: 0 auto;
      height: 480px;
      // overflow: hidden;
      .enp {
        line-height: 26px;
      }
      .left {
        float: left;
        width: 820px;
        height: 480px;
        padding-top: 105px;
        .ft36 {
          font-size: 32px;
        }
        .title {
          color: #fff;
          font-weight: 400;
          height: 60px;
        }
        .marginTop {
          font-weight: normal;
          line-height: 26px;
          font-size: 14px;
        }
      }
      .right {
        position: absolute;
        top: 22px;
        right: -27px;
        width: 645px;
        height: 346px;
        .right_img {
          position: relative;
        }
        .none {
          visibility: hidden;
          z-index: -1;
        }
        .block {
          visibility: visible;
          z-index: 1;
        }
        .content_box {
          background: url("./../../assets/images/blockChain/newBanner/zjyb_img.png")
            no-repeat;
          position: absolute;
          width: 213px;
          height: 51px;
          top: 120px;
          left: 490px;
          color: #fff;
          padding: 0 10px;
          padding-top: 15px;
          padding-left: 56px;
          text-align: center;
          font-size: 12px;
        }
        .swiper-con {
          background: url("./../../assets/images/blockChain/newBanner/gzc_banner_img.png")
            no-repeat;
          position: absolute;
          width: 216px;
          height: 77px;
          top: 177px;
          left: 428px;
          color: #fff;
          padding: 0 10px;
          padding-top: 9px;
          padding-left: 56px;
          text-align: center;
          font-size: 14px;
          background-size: 100% 100%;
          .swiper-container {
            width: 100%;
            height: 100%;
            margin-left: auto;
            margin-right: auto;
            .swiper-slide {
              color: rgba(255, 255, 255, 0.3);
              font-size: 12px;
            }
            .swiper-slide-next {
              color: #fff !important;
              font-size: 13px;
            }
          }
        }
        .content_bank {
          position: absolute;
          width: 216px;
          height: 77px;
          top: 241px;
          left: 370px;
        }
      }
    }
  }
  .currentBlocks {
    width: 100%;
    min-height: 419px;
    padding-bottom: 30px;
    .currentBlocks_title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 1200px;
      margin: 0 auto;
      height: 60px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      img {
        margin-right: 4px;
      }
    }
    .blockOverview {
      width: 100%;
      display: flex;
      justify-content: space-around;
      height: 118px;
      align-items: center;
      background: url("../../assets/images/blockChain/Overview_bg.png")
        no-repeat;
      background-position: center center;
      background-size: contain;
      .blockOverview_item {
        text-align: center;
        p:nth-child(1) {
          font-size: 20px;
          font-family: MicrosoftYaHei;
          color: #969696;
          padding-bottom: 5px;
        }
        p:nth-child(2) {
          font-size: 30px;
          font-family: MicrosoftYaHei;
          color: #000000;
        }
      }
    }
    .currentBlockDatas {
      display: flex;
      width: 1200px;
      min-height: 207px;
      margin: 0 auto;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      border: 1px solid #e0e0e0;
      .BlockDatas_nav {
        width: 244px;
        min-height: 207px;
        flex-shrink: 0;
        border-right: 1px solid #e0e0e0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        p {
          width: 100%;
          height: 45px;
          font-size: 18px;
          color: #333332;
          text-align: center;
          line-height: 45px;
          cursor: pointer;
          flex-shrink: 0;
          margin: 10px 0px;
          background: #dbebfd;
        }
        // P:hover{
        //   background: #d2e6fd;
        // }
        .blankActive {
          background: #345ba5 !important;
          color: #fff !important;
        }
      }
      .BlockDatas_info {
        width: 100%;
        display: flex;
        height: 100%;
        align-items: center;
        .vertical_line {
          width: 1px;
          height: 80px;
          background: #dcdcdc;
        }
      }
      .lefts {
        flex: 1;
        // padding-top: 26px;
        margin-top: -4px;
        text-align: center;
        .color {
          color: #666;
        }
        .nums {
          display: block;
          text-align: center;
          padding: 0 20px;
          margin-top: 20px;
          font-size: 30px;
          font-weight: 400;
          color: #000000;
          p:nth-child(2) {
            padding-top: 10px;
          }
        }
        img {
          vertical-align: bottom;
        }
      }
    }
  }
  .searchBlock {
    width: 100%;
    height: 318px;
    background: #f5f8fa;
    position: relative;
    .table {
      width: 1200px;
      background: #fff;
      position: absolute;
      top: 130px;
      left: 50%;
      margin-left: -600px;
      .err {
        text-align: center;
        color: #868686;
        width: 1200px;
        height: 99px;
        float: left;
        background: #fff;
        line-height: 99px;
      }
      .head {
        width: 1200px;
        height: 42px;
        background: #f3f4f5;
        border: 1px solid #eaeaea;
        .borderLeft {
          border-left: 1px solid #eaeaea;
        }
        span {
          display: inline-block;
          line-height: 42px;
          text-align: center;
          color: #595959;
        }
      }
    }
    .lizi {
      height: 318px;
    }
    .input {
      width: 497px;
      height: 46px;
      margin: 0 auto;
      position: absolute;
      top: 50px;
      left: 50%;
      margin-left: -249px;
    }
  }
  .chainRecord_table_nav {
    width: 1200px;
    margin: 0 auto;
    border-bottom: 1px solid #d8d8d8;
    margin-bottom: 20px;
    .chainRecord_table_nav_con {
      width: 100%;
      display: flex;
      justify-content: space-around;
      box-sizing: border-box;
      padding: 0 80px;
      .chainRecord_table_nav_item {
        width: 200px;
        height: 100%;
        text-align: center;
        cursor: pointer;
        p {
          font-size: 16px;
          font-weight: 500;
          color: #323232;
          margin-bottom: 10px;
        }
        .table_nav_active {
          color: #0a57c9;
        }
        div {
          width: 100%;
          height: 3px;
          background: transparent;
        }
        .table_nav_line {
          background: #0a57c9;
        }
        &:hover p {
          color: #0a57c9;
        }
      }
    }
  }
  .chainRecord {
    margin: 0 auto;
    display: block;
    margin-top: 40px;
  }
  .ft28 {
    text-align: center;
    color: #373737;
    margin-top: 20px;
  }
  .tab {
    width: 1200px;
    margin: 0 auto;
  }

  .jieshao {
    text-align: center;
    color: #373737;
    margin-top: 50px;
    margin-bottom: 50px;
    font-weight: bold;
  }
  .allianceChain {
    width: 100%;
    height: 356px;
    background: #1f448a;
    .allianceChainNew {
      width: 1200px;
      height: 100%;
      position: relative;
      margin: 0 auto;
    }
    .allianceChainCon {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      .item_01,
      .item_02,
      .item_03,
      .item_04,
      .item_05 {
        &:hover {
          .item_0001,
          .item_0002,
          .item_0003,
          .item_0004,
          .item_0005 {
            position: absolute;
            top: 0px;
          }
          .img_01,
          .img_02,
          .img_03,
          .img_04,
          .img_05,
          .p_01,
          .p_02,
          .p_03,
          .p_04,
          .p_05 {
            display: none;
          }
        }
      }
      .item {
        width: 300px;
        height: 356px;
        float: left;
        position: relative;
        padding-top: 135px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        .item_001 {
          width: 300px;
          height: 420px;
          position: absolute;
          top: 356px;
          left: 0px;
          padding-top: 30px;
          color: #fff;
          text-align: center;
          background: rgba(73, 114, 191, 0.6);
          transition: top 2s ease;
        }
        .ft20 {
          margin-top: 20px;
        }
        .con {
          line-height: 22px;
          margin-top: 20px;
          padding: 0 17px;
          text-align: left;
          font-size: 14px;
        }
        .bg {
          position: absolute;
          left: 0;
          top: 0px;
        }
        img {
          position: relative;
        }
        p {
          position: relative;
        }
      }
    }
  }
  .enAllianceChain {
    height: 436px;
    .allianceChainCon {
      .item {
        width: 300px;
        height: 436px;
        .bg {
          height: 100%;
        }
        .item_001 {
          top: 436px;
          height: 436px;
        }
      }
    }
  }
  .advantage {
    color: #333;
    text-align: center;
    margin-top: 50px;
    font-weight: bold;
  }
  .advantageCon {
    width: 1200px;
    height: 230px;
    margin: 0 auto;
    overflow: hidden;
    margin-top: 60px;
    margin-bottom: 20px;
    padding-left: 38px;
    padding-top: 20px;
    .marginLeft150 {
      margin-left: 150px;
    }
    .item {
      width: 160px;
      height: 186px;
      text-align: center;
      display: inline-block;
      cursor: pointer;
      padding: 0 4px;
      vertical-align: top;
      .info {
        color: #333;
        margin-top: 30px;
      }
      &:hover {
        // box-shadow: 4px 4px 10px #e6e6e6;
        box-shadow: 0px 8px 30px #cac3c3;
      }
    }
  }
}
</style>
<style>
.headTable th {
  background-color: #f3f4f5 !important;
  font-size: 14px;
  color: #595959;
}
.el-input-group__append {
  background: #345ba5;
  border-radius: 0px 4px 4px 0px;
  border: 1px solid #345ba5;
}
.el-input-group__append:hover {
  background: #264a8f;
  border-radius: 0px 4px 4px 0px;
  border: 1px solid #264a8f;
}
.el-icon-search {
  color: #fff;
  font-size: 20px;
}
.el-table .warning-row {
  background: #fbfcfc;
}
</style>

